import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";


@Injectable({ providedIn: 'root' })
export class OrderEntrySharedService {

  cityDataSource = new BehaviorSubject<any>(null);
  cityData = this.cityDataSource.asObservable();

  orderTypeSource = new BehaviorSubject<any>(null);
  orderTypeData = this.orderTypeSource.asObservable();

  constructor() { }

  setCityData(data: any) {
    this.cityDataSource.next(data);
  }

  setOrderTypeData(data: any) {
    this.orderTypeSource.next(data);
  }

}